import { api } from '../api';

export interface CuestionariosSaludStats {
  legajosElegibles: number;
  legajosPorEstado: Record<string, number>;
  asociadosTotales: number;
  ddjjCompletadas: number;
  /** Personas (titular o familiar) con al menos una preexistencia declarada. */
  personasConPreexistencias: number;
  preguntasDelCatalogo: number;
}

export async function getCuestionariosSaludStats(): Promise<CuestionariosSaludStats> {
  const { data } = await api.get<CuestionariosSaludStats>(
    '/admin/cuestionarios-salud/stats',
  );
  return data;
}

function parseFilename(cd: string | undefined, fallback: string): string {
  const m = (cd ?? '').match(/filename="?([^"]+)"?/i);
  return m?.[1] ?? fallback;
}

function triggerDownload(data: ArrayBuffer, filename: string): void {
  const blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

export interface DescargaCuestionariosResultado {
  filename: string;
}

export async function descargarCuestionariosSaludBlob(): Promise<DescargaCuestionariosResultado> {
  const res = await api.get('/admin/cuestionarios-salud/exportar', {
    responseType: 'blob',
  });
  const filename = parseFilename(
    res.headers['content-disposition'] as string | undefined,
    'cuestionarios-salud.xlsx',
  );
  triggerDownload(res.data, filename);
  return { filename };
}
